import type { FC } from "react";
import { Modal, ModalContentWithOverlay, ModalHeader, ModalTitle } from "../primitives/modal";
import { ParagraphRegular } from "../primitives/typographies";
import { SourcesList } from "./sources-list";
import type { SourceUrlUIPart } from "ai";

type SourcesModalProps = {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  sources?: SourceUrlUIPart[];
  container?: Element | null;
};

export const SourcesModal: FC<SourcesModalProps> = ({
  isOpen,
  onOpenChange,
  sources,
  container,
}) => {
  return (
    <Modal open={isOpen} onOpenChange={onOpenChange}>
      <ModalContentWithOverlay container={container}>
        <ModalHeader>
          <ModalTitle>
            {`Sources (${sources?.length ?? 0})`}
          </ModalTitle>
        </ModalHeader>
        {sources && sources.length > 0 ? (
          <SourcesList sources={sources} />
        ) : (
          <ParagraphRegular>
            No sources available for this response.
          </ParagraphRegular>
        )}
      </ModalContentWithOverlay>
    </Modal>
  );
};
